import * as format from '../utils/number';

export const formatCurrency = format.formatCurrency;

export const formatNumber = format.formatNumber;
